import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ChevronDown, HelpCircle } from "lucide-react";

export function HelpAdmin() {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  const [texts, setTexts] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open || rows) { return; }
    api.get("/admin/help").then(({ data }) => { setRows(data); setTexts(Object.fromEntries(Object.entries(data).map(([k, v]) => [k, v.text]))); }).catch((e) => toast.error(formatApiError(e)));
  }, [open, rows]);
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(Object.entries(texts).map(([k, v]) => [k, v === rows[k].default ? "" : v]));
      const { data } = await api.put("/admin/help", { texts: body }); setRows(data); toast.success("Textos de ajuda salvos");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <section data-testid="help-admin" className="rounded-2xl border border-zinc-800 bg-zinc-900/40">
      <button type="button" data-testid="help-admin-toggle" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4">
        <span className="flex items-center gap-2 font-display text-lg font-bold uppercase text-zinc-100"><HelpCircle className="h-5 w-5 text-green-neon" /> Ajuda nas telas</span>
        <ChevronDown className={`h-5 w-5 text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && rows && (
        <div className="px-4 pb-4 space-y-3">
          {Object.entries(rows).map(([k, v]) => (
            <label key={k} className="block space-y-1">
              <span className="text-xs font-bold text-zinc-300">{v.title} {texts[k] !== v.default && <span className="text-[10px] text-amber-300">(editado)</span>}</span>
              <textarea data-testid={`help-admin-${k}`} value={texts[k] || ""} onChange={(e) => setTexts((t) => ({ ...t, [k]: e.target.value }))} rows={2} maxLength={800}
                className="w-full rounded-md bg-zinc-900 border border-zinc-800 p-2 text-sm text-zinc-100" />
              {texts[k] !== v.default && <button type="button" onClick={() => setTexts((t) => ({ ...t, [k]: v.default }))} className="text-[11px] text-zinc-500 underline">voltar ao texto padrão</button>}
            </label>
          ))}
          <Button data-testid="help-admin-save" onClick={save} disabled={busy} className="bg-green-brand hover:bg-green-brandDark text-white font-bold">Salvar textos</Button>
        </div>
      )}
    </section>
  );
}
